// extracted by mini-css-extract-plugin
export default {"background":"SignIn_background__dhC1z","loginFormContainer":"SignIn_loginFormContainer__bUDmw"};